import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { submit as submitSettingForm, initialize } from 'redux-form';
import { loadPlaces, loadTickettypes } from '../../redux';
import { changeSetting } from '../../redux/modules/settings';
import { Utils } from '../../services';
import IntegrationsMarketplace from './IntegrationsMarketplace/IntegrationsMarketplace';
import IntegrationConfig from './IntegrationConfig/IntegrationConfig';
import {
    integrations_catalog_path,
    integrations_config_path,
    parse_settings_field_route,
} from './integrationRouteUtils';
import { get_integration_entry } from './integrationCatalog';

import './IntegrationsForm.scss';

const IntegrationsForm = () => {
    const { user }        = useSelector(state => state.auth);
    const { places }      = useSelector(state => state.places);
    const { tickettypes } = useSelector(state => state.tickettypes);
    const dispatch        = useDispatch();
    const { setting }     = useSelector(state => state.settings);
    const integrations = useMemo(
        () => setting?.integrations || {},
        [setting?.integrations]
    );
    const default_settings = Utils.integrationParams;
    const navigate        = useNavigate();
    const { settingId, '*': route_splat } = useParams();
    const { integration_key } = parse_settings_field_route(route_splat);

    useEffect(() => {
        dispatch(loadPlaces());
        dispatch(loadTickettypes());
    }, [dispatch]);

    useEffect(() => {
        if (!integration_key || !settingId || !setting)
            return;

        const entry = get_integration_entry(integration_key);
        if (!entry || (entry.superadminOnly && !user.isSuperAdmin()))
            navigate(integrations_catalog_path(settingId));
    }, [integration_key, settingId, setting, navigate, user]);

    const add_integration = (name) => {
        const updated_setting = {
            ...setting,
            integrations: {
                ...(setting.integrations || {}),
                [name]: default_settings[name],
            },
        };
        dispatch(changeSetting(updated_setting));
        dispatch(initialize('settingForm', { ...updated_setting }));
        navigate(integrations_config_path(settingId, name));
        dispatch(submitSettingForm('settingForm'));
    };

    const handle_activate = (name) => {
        if (integrations[name])
            navigate(integrations_config_path(settingId, name));
        else
            add_integration(name);
    };

    const handle_configure = (name) => {
        navigate(integrations_config_path(settingId, name));
    };

    if (integration_key && get_integration_entry(integration_key)) {
        return (
            <div className="IntegrationsForm">
                <IntegrationConfig
                    integration_key={integration_key}
                    places={places}
                    tickettypes={tickettypes}
                />
            </div>
        );
    }

    return (
        <div className="IntegrationsForm">
            <IntegrationsMarketplace
                integrations={integrations}
                is_superadmin={user.isSuperAdmin()}
                onActivate={handle_activate}
                onConfigure={handle_configure}
            />
        </div>
    );
};

export default IntegrationsForm;
